/* ################################################################### */
/* FUNCTION (SAME HEIGHT) ############################################ */
/* ################################################################### */
function sameHeight(elem)
{
	if(jQuery(window).width() > 768)
	{
		jQuery('.sh_container').each(function()
		{
			var h_elem = 0;

			jQuery('.sh_element', jQuery(this))
				.css({ 'height' : '' })
				.each(function()
				{
					if(h_elem < jQuery(this).height())
						h_elem = jQuery(this).height();
				})
				.height(h_elem);
		});
	}
	else
		jQuery('.sh_element', '.sh_container').css('height', '');
}

